<template>
    <div>
        <div class="tickets-row__details">
            <Status
                :status="status"
            />
            <div class="tickets-cell played">
                <span>{{ dateReceived | formatDateTime('ddmmyyyyHHMM') }}</span>
            </div>
            <div class="tickets-cell type">
                <span class="bet-type">{{ $t(type) }}</span>
                <span class="delimiter" />
                <span class="bet-system"> {{ `${system ? $t('system') : $t('simple')}` }} </span>
            </div>
            <div class="tickets-cell bet-id">
                <span>{{ id }}</span>
            </div>
        </div>
        <div class="tickets-row__amounts">
            <div
                :title="coefficient"
                class="tickets-cell coefficient"
            >
                <span class="value">{{ coefficient | twoDecimals }}</span>
            </div>
            <div class="tickets-cell stake">
                <span>{{ stake | twoDecimals }}</span>
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
            <div class="tickets-cell payoff">
                <template v-if="payoff">
                    <span>{{ payoff | twoDecimals }}</span>
                    <span class="currency">{{ $t('currencyAbbreviation') }}</span>
                </template>
                <template v-else>
                    -
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import TicketRowMixin from './TicketRowMixin';

    export default {
        mixins: [TicketRowMixin],
    };
</script>

<style>
    .tickets-cell {
        display: table-cell;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/tickets/components/ResolvedTicketRow.vue